// ref https://www.30secondsofcode.org/js/s/arrays-have-same-contents/
export const checkArrayhaveSameContents = <T>(a: T[], b: T[]): boolean => {
  for (const v of new Set([...a, ...b]))
    if (a.filter((e) => e === v).length !== b.filter((e) => e === v).length)
      return false;
  return true;
};
